import styled from 'styled-components'

export const MetaList = styled.dl`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  margin: 0;
  flex-shrink: 0;
`

export const MetaRow = styled.div`
  display: grid;
  grid-template-columns: minmax(4.75rem, 30%) minmax(0, 1fr);
  gap: 0.75rem;
  align-items: center;
`

export const MetaLabel = styled.dt`
  min-width: 0;
`

export const MetaValue = styled.dd`
  min-width: 0;
  margin: 0;
  overflow-wrap: anywhere;
`
